/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = import.meta.env.VITE_SITECORE_API_KEY || "{E95F20BA-4F8B-44A6-8723-BEEEA0936AA5}";
config.sitecoreApiHost = import.meta.env.VITE_SITECORE_API_HOST || "https://zka.zdn.local";
config.sitecoreSiteName = import.meta.env.VITE_SITECORE_SITE_NAME || "product-pages";
export default config;